"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconBot = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconBot = function SvgIconBot(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 1.86622C6.7989 1.69331 7 1.37014 7 1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1C5 1.37014 5.2011 1.69331 5.5 1.86622V3.4H3C2.11634 3.4 1.4 4.11634 1.4 5V10C1.4 10.8837 2.11634 11.6 3 11.6H9C9.88366 11.6 10.6 10.8837 10.6 10V5C10.6 4.11634 9.88366 3.4 9 3.4H6.5V1.86622ZM0 7C0 6.44772 0.447715 6 1 6V9C0.447715 9 0 8.55228 0 8V7ZM12 7C12 6.44772 11.5523 6 11 6V9C11.5523 9 12 8.55229 12 8V7ZM3 4.6C2.77909 4.6 2.6 4.77909 2.6 5V10C2.6 10.2209 2.77909 10.4 3 10.4H9C9.22091 10.4 9.4 10.2209 9.4 10V5C9.4 4.77909 9.22091 4.6 9 4.6H3ZM4 9C4.55228 9 5 8.55229 5 8C5 7.44772 4.55228 7 4 7C3.44772 7 3 7.44772 3 8C3 8.55229 3.44772 9 4 9ZM9 8C9 8.55229 8.55229 9 8 9C7.44772 9 7 8.55229 7 8C7 7.44772 7.44772 7 8 7C8.55229 7 9 7.44772 9 8Z",
    fill: "currentColor"
  }));
};

exports.SvgIconBot = SvgIconBot;